import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying | success | error

  useEffect(() => {
    const verifyEmail = async () => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("token");

      if (!token) {
        setStatus("error");
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/auth/verify-email?token=${token}`
        );

        const data = await response.json();

        // If backend says success OR already verified → treat as success
        if (data.success) {
          setStatus("success");
          setTimeout(() => navigate("/login"), 4000);
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error("❌ Email verification failed:", err);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [location.search, navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "Poppins, Arial, sans-serif",
        backgroundColor: "#f9fafb",
        color: "#333",
        textAlign: "center",
        padding: "20px",
      }}
    >
      {status === "verifying" && (
        <>
          <h2>Verifying your email...</h2>
          <p>Please wait while we confirm your account.</p>
        </>
      )}

      {status === "success" && (
        <div style={{ maxWidth: "520px" }}>
          <h2 style={{ color: "#2e7d32", fontWeight: "600" }}>
            ✅ Email Verified Successfully!
          </h2>
          <p style={{ marginTop: "10px", fontSize: "15px" }}>
            Welcome to <strong>Client Exchange</strong> — your email has been
            verified.
          </p>
          <p style={{ marginTop: "10px", fontSize: "15px" }}>
            To keep our marketplace safe and secure for all contractors, the next
            step is to <strong>log in</strong> and complete your driver’s licence
            verification.
          </p>
          <p style={{ marginTop: "10px", fontSize: "15px" }}>
            Once logged in, you’ll be taken to the licence verification step to
            complete your account setup.
          </p>

          <button
            onClick={() => navigate("/login")}
            style={{
              marginTop: "25px",
              background: "linear-gradient(90deg, #2e7d32, #43a047)",
              color: "white",
              border: "none",
              borderRadius: "10px",
              padding: "12px 28px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "opacity 0.2s ease",
              boxShadow: "0px 3px 6px rgba(0,0,0,0.15)",
            }}
            onMouseOver={(e) => (e.target.style.opacity = 0.9)}
            onMouseOut={(e) => (e.target.style.opacity = 1)}
          >
            Continue to Login →
          </button>

          <p style={{ marginTop: "15px", color: "#666", fontSize: "13px" }}>
            Redirecting automatically in a few seconds...
          </p>
        </div>
      )}

      {status === "error" && (
        <>
          <h2 style={{ color: "red" }}>Verification Failed</h2>
          <p>
            The verification link may be invalid or expired. Please check your
            email or try registering again.
          </p>
        </>
      )}
    </div>
  );
};

export default VerifyEmail;